import { useNavigate } from 'react-router-dom';

export const LandingIntro = () => {
    const navigate = useNavigate();

    return (
        <section className="py-20 bg-white">
            <div className="max-w-4xl mx-auto px-6 text-center">
                <h2 className="text-4xl lg:text-5xl font-black text-gray-900 mb-6 leading-tight">
                    Revolucione a Comunicação do seu Negócio com <span className="text-primary">Telas Dinâmicas</span>
                </h2>
                <p className="text-xl lg:text-2xl text-gray-500 font-medium leading-relaxed">
                    Conecte-se com seus clientes de forma inovadora. Nossa plataforma transforma qualquer TV em um canal de marketing e vendas poderoso, gerenciado em nuvem.
                </p>
            </div>
        </section>
    );
};
